import { CALENDAR_MODE } from '@/components/core/calendar/constants';

export const defaultFilterValues = (optionMap) => Object.values(optionMap).map((o) => o.value);

export const CHANNEL_FILTER_OPTIONS = Object.freeze({
  INSTAGRAM: { label: 'instagram', value: 'INSTAGRAM', icon: 'instagram-color' },
  INSTAGRAM_REEL: {
    label: 'instagramReel',
    value: 'INSTAGRAM_REEL',
    icon: 'instagram-reel-color',
  },
  INSTAGRAM_STORY: {
    label: 'instagramStory',
    value: 'INSTAGRAM_STORY',
    icon: 'instagram-story-color',
  },
  TIKTOK: { label: 'tiktok', value: 'TIKTOK', icon: 'tiktok-color' },
  FACEBOOK: { label: 'facebook', value: 'FACEBOOK', icon: 'facebook-color' },
  PINTEREST: { label: 'pinterest', value: 'PINTEREST', icon: 'pinterest-color' },
  YOUTUBE: { label: 'youtube', value: 'YOUTUBE', icon: 'youtube-short-color' },
  LINKEDIN: { label: 'linkedin', value: 'LINKEDIN', icon: 'linkedin-color' },
  THREADS: { label: 'threads', value: 'THREADS', icon: 'threads-color' },
  TWITTER: { label: 'twitter', value: 'TWITTER', icon: 'twitter-color' },
  BLUESKY: { label: 'bluesky', value: 'BLUESKY', icon: 'bluesky-color' },
  SNAPCHAT: { label: 'snapchat', value: 'SNAPCHAT', icon: 'snapchat-color' },
});

export const APPROVAL_STATUS_FILTER_OPTIONS = Object.freeze({
  ASSIGNED_TO_YOU: { label: 'Assigned to You', value: 'ASSIGNED_TO_YOU' },
  UNASSIGNED: { label: 'Unassigned', value: 'UNASSIGNED' },
  APPROVED: { label: 'Approved', value: 'APPROVED' },
  PENDING: { label: 'Pending Approval', value: 'PENDING' },
});

export const CALENDAR_VIEW_OPTIONS = Object.freeze({
  WEEK: { label: 'Week', value: CALENDAR_MODE.WEEK },
  MONTH: { label: 'Month', value: CALENDAR_MODE.MONTH },
});

export const BRAND_ID_FILTER_SORT = 'brands';
export const BRAND_TAG_FILTER_SORT = 'brandTags';
export const BRAND_ID_FILTER_FIELD = 'brandIds';
export const BRAND_TAG_FILTER_FIELD = 'brandTagIds';

export const BRAND_FILTER_OPTIONS = Object.freeze({
  label: 'Brands',
  sortOptions: [
    {
      value: BRAND_ID_FILTER_SORT,
      label: 'Brands',
    },
    {
      value: BRAND_TAG_FILTER_SORT,
      label: 'Brand Tags',
    },
  ],
});

export const tagsFilterDisabledTooltip = 'Clear the selected brands to choose brand tags';
export const brandsFilterDisabledTooltip = 'Clear the selected brand tags to choose brands';

export const SCHEDULER_SCOPED_FILTERS = {
  SCHEDULER: {
    scope: 'scheduler',
    options: {
      channels: defaultFilterValues(CHANNEL_FILTER_OPTIONS),
      approvalStatuses: Object.values(APPROVAL_STATUS_FILTER_OPTIONS),
      brands: BRAND_FILTER_OPTIONS.sortOptions,
    },
    default: {
      channels: [],
      approvalStatuses: [],
      showDrafts: true,
      brandIds: [],
      brandTagIds: [],
    },
  },
};

export const SCHEDULER_DEFAULT_FILTERS = Object.freeze({
  channels: defaultFilterValues(CHANNEL_FILTER_OPTIONS),
  approvalStatuses: [],
  calendarView: CALENDAR_VIEW_OPTIONS.WEEK.value,
  showDrafts: true,
});
